if (!customElements.get('pw-stock-status')) customElements.define('pw-stock-status', class extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    this.host = this.closest('pw-product');
    this.variants = JSON.parse(this.querySelector('[data-stock-variants]').textContent);
    this.controller = new AbortController();
    this.host.addEventListener('change', () => requestAnimationFrame(() => this.update()), {signal: this.controller.signal});
    this.observer = new MutationObserver(() => this.update());
    this.observer.observe(this.host.querySelector('.pw-product-details'), {childList:true, subtree:true});
    this.update();
  }
  disconnectedCallback() { this.controller?.abort(); this.controller = null; this.observer?.disconnect(); }
  update() {
    const checked = this.host.querySelector('.bundle-qty-deal__radio:checked');
    const selectedOffer = checked?.parentElement.querySelector('.bundle-qty-option');
    const rows = selectedOffer ? [...selectedOffer.querySelectorAll('.bundle-qty-options-row')] : [];
    const find = values => this.variants.find(v => v.options.every((value, i) => value === values[i]));
    let variants = rows.map(row => find([...row.querySelectorAll('select')].map(s => s.value)));
    if (!variants.length) {
      const id = this.host.querySelector('[data-variant-id]')?.value;
      variants = [this.variants.find(v => String(v.id) === id) || this.variants[0]];
    }
    let state = 'available';
    if (variants.some(v => !v?.available)) state = 'sold';
    else if (variants.some(v => v.tracked && v.policy === 'deny' && v.quantity > 0 && v.quantity <= Number(this.dataset.threshold))) state = 'low';
    this.dataset.state = state;
    const label = this.querySelector('[data-stock-label]');
    if (label.textContent !== this.dataset[state]) label.textContent = this.dataset[state];
  }
});
document.addEventListener('click', async event => {
  const button = event.target.closest('[data-copy-code]');
  if (!button) return;
  try {
    await navigator.clipboard.writeText(button.dataset.copyCode);
    button.closest('.pw-bf-promotion').querySelector('.pw-bf-copy-status').textContent = button.dataset.copiedLabel;
    button.textContent = button.dataset.copiedLabel;
    setTimeout(() => { if(button.isConnected) button.textContent = button.dataset.copyCode; }, 1800);
  } catch { button.focus(); }
});
